module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EditCardView.js"));
	}, "EditCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EditCardView!./src/pages/Promote/BusinessCard/EditCard/EditCardView.js
// module id = 1127
// module chunks = 431